const PLAYER_VARS = {
    autoplay: 1,
    cc_load_policy: 0,
    controls: 0,
    disablekb: 1,
    iv_load_policy: 3,
    loop: 1,
    mute: 1,
    playsinline: 1,
    rel: 0,
};

let ytApi = null;

const loadYouTubeApi = () => {
    if (ytApi) return ytApi;

    ytApi = new Promise((resolve) => {
        if (window.YT?.Player) return resolve(window.YT);

        // 共通の動画モーダルと同じAPIを使うため、既存のコールバックも実行する
        const prevCallback = window.onYouTubeIframeAPIReady;

        window.onYouTubeIframeAPIReady = () => {
            if (prevCallback) prevCallback();
            resolve(window.YT);
        };

        if (document.querySelector('script[src*="youtube.com/iframe_api"]')) return;

        const $script = document.createElement("script");

        $script.src = "https://www.youtube.com/iframe_api";
        document.head.appendChild($script);
    });

    return ytApi;
};

export default class NewteamMovie {
    constructor() {
        this.$target = document.querySelector(".js-howto4th-newteam-movie-preview");

        if (!this.$target) return;

        this.videoID = this.$target.closest(".js-moviemodal_btn")?.dataset.videoid;

        if (this.videoID) this.setup();
    }

    async setup() {
        const YT = await loadYouTubeApi();

        if (!this.$target.isConnected) return;

        this.player = new YT.Player(this.$target, {
            height: "100%",
            width: "100%",
            playerVars: {
                ...PLAYER_VARS,
                playlist: this.videoID,
            },
            events: {
                // モーダルと同じく、プレイヤー生成後に動画IDを渡す
                onReady: ({ target }) => target.loadVideoById({ videoId: this.videoID }),
                onStateChange: ({ data, target }) => {
                    if (data === YT.PlayerState.PLAYING) {
                        target.unloadModule("captions");
                        target.unloadModule("cc");
                    } else if (data === YT.PlayerState.PAUSED) {
                        target.playVideo();
                    } else if (data === YT.PlayerState.ENDED) {
                        target.seekTo(0);
                        target.playVideo();
                    }
                },
            },
        });

        this.player.getIframe().classList.add("howto4th-newteam__movie-preview");
    }
}
